import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login-heatwave',
  templateUrl: './login-heatwave.component.html',
  styleUrls: ['./login-heatwave.component.scss']
})
export class LoginHeatwaveComponent implements OnInit {
  UserData: object = { login: '', password: '' }
  Storage: any;
  loggedIn: void;
  flag: boolean;
  constructor(private toastr: ToastrService, private router: Router,
    private route: ActivatedRoute
  ) { }
  stateLoginID = {
    JHARKHAND: {
      userid: 'jharkhand',
      pwd: '123',
      centroid: {
        "lat": 23.6532514568,
        "lon": 85.5924284103
      },
      uuid: 'def856bd-68bf-499f-adbf-8bfb59c426fa'
    },
    UTTARPRADESH: {
      userid: 'uttarpradesh',
      pwd: '123',
      centroid: {
        "lat": 27.0311125656,
        "lon": 80.7159608284
      },
      uuid: 'e34c16d5-bfde-4257-9bd7-adf80d580cb1'
    },
    ODISHA: {
      userid: 'odisha',
      pwd: '123',
      centroid: {
        "lat": 20.3522679589,
        "lon": 84.4290112208
      },
      uuid: 'ed9ab30c-7686-4529-8e51-efa750184538'
    },
    CHHATTISGARH: {
      userid: 'chhattisgarh',
      pwd: '123',
      centroid: {
        "lat": 20.3522679589,
        "lon": 84.4290112208
      },
      uuid: 'daabd0d9-51a2-4563-ac28-2daafcda5f95'
    },
    JAMMUANDKASHMIR: {
      userid: 'jammuandkashmir',
      pwd: '123',
      centroid: {
        "lat": 33.6897644585,
        "lon": 33.6897644585
      },
      uuid: '3d62dad7-cca9-4b02-aff7-220a1e29434a'
    },
    KERALA: {
      userid: 'kerala',
      pwd: '123',
      centroid: {
        "lat": 10.4970560821,
        "lon": 76.2737761915
      },
      uuid: "62d3dc99-5bc3-4303-8be1-d4fa1f7deee5"
    },
    SIKKIM: {
      userid: 'sikkim',
      pwd: '123',
      centroid: {
        "lat": 27.5885801094,
        "lon": 88.4752650961
      },
      uuid: "3e18e14b-267d-4995-b886-d0eb9956036b"
    },
    WESTBENGAL: {
      userid: 'westbengal',
      pwd: '123',
      centroid: {
        "lat": 24.0473201003,
        "lon": 87.9283432946
      },
      uuid: '119ff4d9-357d-46e7-a33a-341a10e2e26f'
    },
    ANDAMANISLANDS: {
      userid: 'andamanislands',
      pwd: '123',
      centroid: {
        "lat": 10.6013357638,
        "lon": 93.1097991729
      },
      uuid: '80ff77b4-eab6-4d8a-a5cd-6d176b781de1'
    },
    ARUNACHALPRADESH: {
      userid: 'arnuachalpradesh',
      pwd: '123',
      centroid: {
        "lat": 28.0480760788,
        "lon": 94.5964107612
      },
      uuid: '13d8716c-00e0-4539-a298-ce82c657ffc9',
    },
    LADAKH: {
      userid: 'ladakh',
      pwd: '123',
      centroid: {
        "lat": 34.8258630201,
        "lon": 76.614248676
      },
      uuid: 'a47662d4-abd0-4887-8d1d-1fa3452a903e',
    },
    PUNJAB: {
      userid: 'punjab',
      pwd: '123',
      centroid: {
        "lat": 30.9350464192,
        "lon": 75.4144174553
      },
      uuid: '1da247a7-91d6-4f34-bc59-8d254bc8cbac'
    },
    TRIPURA: {
      userid: 'tripura',
      pwd: '123',
      centroid: {
        "lat": 23.7401358663,
        "lon": 91.741972722
      },
      uuid: 'ec39fb52-4d1e-4985-83db-111657acd6c8',
    },
    Karnataka: {
      userid: 'Karnataka',
      pwd: '123',
      centroid: {
        "lat": 14.8737065148,
        "lon": 76.2520249951
      },
      uuid: 'a98dc358-c9b2-41fd-83b4-88dd372f52c5'
    },
    ASSAM: {
      userid: 'assam',
      pwd: '123',
      centroid: {
        "lat": 26.2037454868,
        "lon": 92.8449853221
      },
      uuid: '0a2f9e86-49fa-4641-af48-f127a02a1a14'
    },
    MADHYAPRADESH: {
      userid: 'madhyapradesh',
      pwd: '123',
      centroid: {
        "lat": 23.7517465696,
        "lon": 78.3545669795
      },
      uuid: '26447ace-a20d-4800-b502-3f7de91470d9'
    },
    BIHAR: {
      userid: 'bihar',
      pwd: '123',
      centroid: {
        "lat": 25.7927096947,
        "lon": 85.7083951867
      },
      uuid: '8ded16b8-ab26-4b55-b2b2-c85e35f59f0d'
    },
    MAHARASHTRA: {
      userid: 'assam',
      pwd: '123',
      centroid: {
        "lat": 19.1331110796,
        "lon": 76.4422581098
      },
      uuid: '3ecbd07b-ecaf-44ed-9686-c2418c5b2517'
    },
    NAGALAND: {
      userid: 'nagaland',
      pwd: '123',
      centroid: {
        "lat": 26.0893354533,
        "lon": 94.3783672009
      },
      uuid: '5ebe53d4-c403-4a6d-9fcd-a238e17d3f96'
    },
    GOA: {
      userid: 'nagaland',
      pwd: '123',
      centroid: {
        "lat": 15.3542983631,
        "lon": 74.0339583159
      },
      uuid: '1aea312c-b078-4620-8865-8168d9e48b5d'
    },
    HARYANA: {
      userid: 'haryana',
      pwd: '123',
      centroid: {
        "lat": 29.2445870363,
        "lon": 76.1886464569
      },
      uuid: 'cb7e28bc-5c32-4d88-a600-592e9c57e3f9'
    },
    GUJARAT: {
      userid: 'gujrat',
      pwd: '123',
      centroid: {
        "lat": 22.5529004938,
        "lon": 71.4450773637
      },
      uuid: 'b8bd1fa0-8e94-407f-8300-1079f63bd28f'
    },
    DELHI: {
      userid: 'delhi',
      pwd: '123',
      centroid: {
        "lat": 28.6412620299,
        "lon": 77.1057867621
      },
      uuid: 'e8a93752-da8b-4571-bbe5-c2cef432dbeb'
    },
    ANDHRAPRADESH: {
      userid: 'andhrapradesh',
      pwd: '123',
      centroid: {
        "lat": 15.8252463722,
        "lon": 80.3636860512
      },
      uuid: 'cdf94322-30bf-456b-b0c6-b4038caebd6a'
    },
    TELANGANA: {
      userid: 'telangana',
      pwd: '123',
      centroid: {
        "lat": 17.8393712018,
        "lon": 79.1425673044
      },
      uuid: '78170895-ec7a-42d6-b39f-2c4eaa001944'
    },
    MEGHALAYA: {
      userid: 'meghalaya',
      pwd: '123',
      centroid: {
        "lat": 25.5545260879,
        "lon": 91.2951068546
      },
      uuid: '7c8e3b6a-7894-419e-ba87-d9bf0976c281'
    },
    MIZORAM: {
      userid: 'mizoram',
      pwd: '123',
      centroid: {
        "lat": 23.2685206223,
        "lon": 92.8423345896
      },
      uuid: 'a60b0a9a-ab0d-45dd-9bda-beb5799f988e'
    },
    TAMILNADU: {
      userid: 'tamilnadu',
      pwd: '123',
      centroid: {
        "lat": 10.9190988104,
        "lon": 78.3478616141
      },
      uuid: 'ce252f37-28d9-42ad-96b7-ec6a3c45d247'
    },
    RAJASTHAN: {
      userid: 'rajasthan',
      pwd: '123',
      centroid: {
        "lat": 26.6067664991,
        "lon": 73.8644550895
      },
      uuid: '6f964ecb-5f36-446b-96ee-ff73887c7e86'
    },
    HIMACHALPRADESH: {
      userid: 'himachalpradesh',
      pwd: '123',
      centroid: {
        "lat": 31.8708120161,
        "lon": 77.2757585485
      },
      uuid: '208bcb98-f554-4344-b2f6-20e831ff43ec'
    },
    UTTARAKHAND: {
      userid: 'uttrakhand',
      pwd: '123',
      centroid: {
        "lat": 30.1204833359,
        "lon": 79.2570584073
      },
      uuid: '331a8262-4b03-4774-803f-7f7f2ecef07a'
    },
    MANIPUR: {
      userid: 'manipur',
      pwd: '123',
      centroid: {
        "lat": 24.7491852684,
        "lon": 93.8709637932
      },
      uuid: 'd533353e-9635-4d4a-89a1-08cfc08c310e'
    },

  }
  ngOnInit() {
    localStorage.clear()
  }

  onSubmit() {

    // let userInfo = JSON.stringify({"userId":"0a8e4210-1b6d-4dba-a286-8132acc31d77","username":"keralakrishistack","firstName":"Kerala","lastName":"Agri","email":"kerala@gmail.com","mobileNo":"+918695556654","userDetailsJson":{"data":{"locType": "State","location":{"country":[{"countryName":"India","countryUUID":"d6b37905-d2d3-4275-9317-d9b6f47cd783","state":[{"stateName":"KERALA","stateUUID":"62d3dc99-5bc3-4303-8be1-d4fa1f7deee5"}]}]}},"scope":null},"createdTs":null,"updatedTs":null,"lastLoginTs":"2023-09-11T07:52:00.000+00:00","status":true,"title":null,"customerId":"55d32109-6d07-4d91-b298-47775d146133","customerName":"agriwisecustomeruser","customAttributes":null, roleName:"LAO"});
    let metaInfo = JSON.stringify({
      "userId": "689f8ae3-bd85-4b5f-975f-2901fd5f5f7f",
      "username": "vassar",
      "firstName": "Aswin",
      "lastName": "Kumar",
      "email": "aswin@vassarlabs.com",
      "mobileNo": "+918897246760",
      "userDetailsJson": {
        "data": {
          "locType": "Country",
          "location": {
            "country": [
              {
                "countryName": "INDIA",
                "countryUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6"
              }
            ]
          }
        },
        "scope": null
      },
      "lastLoginTs": "2025-04-17T07:22:26.214+00:00",
      "status": true,
      "customerId": "f7d86063-2db1-4dd7-bbdf-0e4dc6031744",
      "customerName": "heatwavecustomer"
    })
    localStorage.setItem('metaInfo', metaInfo);
    if ((this.UserData['login'] == 'vassar') && this.UserData['password'] == 'vassar@123') {
      // this.loggedIn = sessionStorage.setItem('logIn','true')
      this.toastr.success("Logged In Successfully")
      // this.router.navigate['home'];
      this.router.navigate(['', 'nhip-dashboard', 'nhip', 'akbm']);
      // this.router.navigate(['landing-page']);
    }
    else if ((this.UserData['login'] == 'cropc') && this.UserData['password'] == 'cropc123$') {
      // this.loggedIn = sessionStorage.setItem('logIn','true')
      this.toastr.success("Logged In Successfully")
      // this.router.navigate['home'];
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);

    }
    else if ((this.UserData['login'] == 'WB') && this.UserData['password'] == 'wb@123') {
      // this.loggedIn = sessionStorage.setItem('logIn','true')
      this.toastr.success("Logged In Successfully")
      // this.router.navigate['home'];
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);

    }
    else if ((this.UserData['login'] == 'abhiyant') && this.UserData['password'] == 'abhi@123') {
      // this.loggedIn = sessionStorage.setItem('logIn','true')
      this.toastr.success("Logged In Successfully")
      // this.router.navigate['home'];
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);

    }
    else if (this.UserData['login'] == this.stateLoginID.JHARKHAND.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.JHARKHAND.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.JHARKHAND.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.JHARKHAND.centroid.lon))

    } else if (this.UserData['login'] == this.stateLoginID.UTTARPRADESH.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'nowcastweather', 'nowcast', '24', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.UTTARPRADESH.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.UTTARPRADESH.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.UTTARPRADESH.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.ODISHA.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.ODISHA.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.ODISHA.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.ODISHA.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.CHHATTISGARH.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.CHHATTISGARH.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.CHHATTISGARH.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.CHHATTISGARH.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.JAMMUANDKASHMIR.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.JAMMUANDKASHMIR.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.JAMMUANDKASHMIR.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.JAMMUANDKASHMIR.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.KERALA.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.KERALA.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.KERALA.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.KERALA.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.SIKKIM.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.SIKKIM.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.SIKKIM.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.SIKKIM.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.WESTBENGAL.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.WESTBENGAL.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.WESTBENGAL.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.WESTBENGAL.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.ANDAMANISLANDS.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.ANDAMANISLANDS.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.ANDAMANISLANDS.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.ANDAMANISLANDS.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.ARUNACHALPRADESH.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.ARUNACHALPRADESH.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.ARUNACHALPRADESH.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.ARUNACHALPRADESH.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.LADAKH.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.LADAKH.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.LADAKH.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.LADAKH.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.PUNJAB.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.PUNJAB.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.PUNJAB.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.PUNJAB.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.TRIPURA.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.TRIPURA.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.TRIPURA.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.TRIPURA.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.Karnataka.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.Karnataka.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.Karnataka.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.Karnataka.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.ASSAM.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.ASSAM.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.ASSAM.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.ASSAM.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.MADHYAPRADESH.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.MADHYAPRADESH.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.MADHYAPRADESH.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.MADHYAPRADESH.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.BIHAR.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.BIHAR.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.BIHAR.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.BIHAR.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.MAHARASHTRA.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.MAHARASHTRA.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.MAHARASHTRA.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.MAHARASHTRA.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.NAGALAND.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.NAGALAND.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.NAGALAND.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.NAGALAND.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.GOA.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.GOA.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.GOA.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.GOA.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.HARYANA.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.HARYANA.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.HARYANA.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.HARYANA.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.GUJARAT.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.GUJARAT.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.GUJARAT.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.GUJARAT.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.DELHI.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.DELHI.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.DELHI.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.DELHI.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.ANDHRAPRADESH.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.ANDHRAPRADESH.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.ANDHRAPRADESH.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.ANDHRAPRADESH.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.TELANGANA.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.TELANGANA.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.TELANGANA.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.TELANGANA.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.MEGHALAYA.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.MEGHALAYA.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.MEGHALAYA.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.MEGHALAYA.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.MIZORAM.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.MIZORAM.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.MIZORAM.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.MIZORAM.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.TAMILNADU.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.TAMILNADU.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.TAMILNADU.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.TAMILNADU.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.RAJASTHAN.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.RAJASTHAN.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.RAJASTHAN.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.RAJASTHAN.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.HIMACHALPRADESH.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.HIMACHALPRADESH.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.HIMACHALPRADESH.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.HIMACHALPRADESH.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.UTTARAKHAND.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.UTTARAKHAND.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.UTTARAKHAND.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.UTTARAKHAND.centroid.lon))
    }
    else if (this.UserData['login'] == this.stateLoginID.MANIPUR.userid && this.UserData['password'] == '123') {
      this.toastr.success("Logged In Successfully")
      this.router.navigate(['', 'heatwatches', 'heatwave', 'akbm']);
      this.Storage = localStorage.setItem('uuid', this.stateLoginID.MANIPUR.uuid)
      this.Storage = localStorage.setItem('lat', String(this.stateLoginID.MANIPUR.centroid.lat))
      this.Storage = localStorage.setItem('lon', String(this.stateLoginID.MANIPUR.centroid.lon))
    }

    else {
      this.toastr.error("username and password does not match")

    }
  }

}
